export const ARCHIVE_CATEGORIES = Object.freeze(['sound', 'merch', 'print', 'events']);
